import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import TwygsAvatar from '../../../../assets/twygs-avatar-notification.svg';
import AlertRedIcon from '../../../../assets/warning-circle-icon.svg';

const ModerationModeratedNotification = ({ notification }) => {
  const meta = getMeta(notification);
  const contentType = meta.contentType === 'comment' ? 'comment' : 'article';
  const reason = meta.reason || 'potentially inappropriate';

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={TwygsAvatar} subIcon={AlertRedIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="font-extrabold text-sm text-growth-green-900">
          Your {contentType} <span className="text-red-600">has been moderated.</span>
        </p>

        {meta.articleTitle && (
          <p
            className={`${
              contentType === 'comment'
                ? 'text-sm text-gray-600 mb-2'
                : 'text-sm text-growth-green-900 font-extrabold mb-2'
            } mt-1`}
          >
            {contentType === 'comment' ? `on "${meta.articleTitle}"` : `"${meta.articleTitle}"`}
          </p>
        )}

        <p className="text-xs text-gray-600">
          <span className="font-bold">Reason:</span> {reason}.
        </p>
      </div>
    </div>
  );
};

export default ModerationModeratedNotification;
